export default __webpack_public_path__ + "assets/b930233c8104d4d8195bada67eb973b4.png";